import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostNaverLogin = () => {
  return useMutation({
    mutationFn: authService.postNaverLogin,
    throwOnError: false,
  });
};
